module.exports = __webpack_public_path__ + "img/step02_bg.1a95c08f.jpg";